import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

interface Props {
  formId?: number;
  entryId?: number;
}
export function DailyReportFormScreen({ formId, entryId }: Props) {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/reports/daily-reporting`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      formId={formId}
      entryId={entryId}
      backPath={backPath}
    />
  );
}
